import { Box, Button, Card, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import InfoTooltip from '../components/InfoTooltip';

import {
  createBanner,
  createContactInfo,
  createShellySettings,
  createTtlockSettings,
  deleteUploads,
  getBanner,
  getContactInfo,
  getShellySettings,
  getTtlockSettings,
  uploadFile,
} from '../helper/backend_helper';
import appConfig from '../config';

// import logo from 'src/components/logo';

const TtlockSetting = () => {
  const [apiKey, setApiKey] = useState('');

  const [loading, setLoading] = useState(false);

  const Banner = async () => {
    try {
      const response = await getTtlockSettings();
      setApiKey(response?.data?.data?.apiKey || '');
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      // Check if any field is empty
      if (apiKey.trim() === '') {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Api Key cannot be empty',
        });
        setLoading(false);
        return;
      }

      const data = {
        apiKey,
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createTtlockSettings(data, Categoryheaders);

      // setTitle('');
      // setFormData({
      //   ...formData,
      //   profileImage: null,
      // });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Shelly Settings',
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> TT Lock Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          // onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <Typography variant="h4">TT Lock Settings{' '}<InfoTooltip width={20} title="Connects Vesuview to your TTLock smart locks through Seam so the platform can read lock status and issue time-limited access codes for guests and cleaners. The single Seam API key saved here authorizes all lock operations across your properties. Paste or update the key on this page and click Update to save it." /></Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: '60ch' },
          }}
          noValidate
          autoComplete="off"
        >
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack>
              <FormLabel sx={{ mb: 1 }}>Seam Api Key <InfoTooltip title="Seam API key authorizing Vesuview to manage your TTLock smart locks, issue access codes, and read lock status." /></FormLabel>
              <TextField
                multiline
                minRows={3}
                label="Enter Seam Api Key"
                id="outlined-size-small"
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
              />
            </Stack>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default TtlockSetting;
